import React, { Suspense } from 'react'
import { Skeleton, Typography } from 'antd'

import { ProposedTenants } from './ProposedTenants'
import './proposed-tenants-page.scss'

export const ProposedTenantsPage = () => {
  return (
    <>
      <Typography.Title className="onboarding-title">Customers Onboarding</Typography.Title>

      <Suspense fallback={<Skeleton />}>
        <ProposedTenants />
      </Suspense>
    </>
  )
}
